import useAxios from '../../hooks/useAxios';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';
import { EApiRoutes, fetchConfig, getApiRouteOrMock } from '../api.utils';
import { EQueryKeys } from '../../constants/enums';
import { NewSettingsPayloadData } from '../../views/Builder/types';

export const usePortalSettings = () => {
  const axios = useAxios();
  const { portalId } = useParams();
  const customHeaders = portalId ? { 'x-portal': portalId } : undefined;

  const getPortalSettingsData = useQuery({
    ...fetchConfig.list,
    queryKey: [EQueryKeys.PORTAL_SETTINGS],
    queryFn: async () => {
      return await axios.get(
        `${getApiRouteOrMock(EApiRoutes.PORTAL_SETTINGS)}`,
        {},
        customHeaders
      );
    }
  });

  const editPortalSettings = useMutation(
    async (newSettingsData: NewSettingsPayloadData) => {
      const response = await axios.put(
        `${getApiRouteOrMock(EApiRoutes.PORTAL_SETTINGS)}`,
        newSettingsData,
        customHeaders
      );
      return response.data;
    },
    {}
  );

  return {
    getPortalSettingsData,
    editPortalSettings
  };
};

export default usePortalSettings;
